import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

export type TableSkeletonColumn = {
  key: string;
  width?: number | string;
  align?: "left" | "right" | "center";
  isCheckbox?: boolean;
};

type Props = {
  columns: TableSkeletonColumn[];
  rowCount?: number;
  minWidth?: number;
};

export default function TableLoadingSkeleton({
  columns,
  rowCount = 6,
  minWidth,
}: Props) {
  return (
    <TableContainer>
      <Table sx={minWidth ? { minWidth } : undefined}>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={`skeleton-header-${column.key}`}
                align={column.align}
                padding={column.isCheckbox ? "checkbox" : undefined}
                sx={column.width ? { width: column.width } : undefined}
              >
                <Skeleton
                  variant="text"
                  width={column.isCheckbox ? 20 : undefined}
                />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <TableRow key={`skeleton-row-${rowIndex}`}>
              {columns.map((column) => (
                <TableCell
                  key={`skeleton-cell-${rowIndex}-${column.key}`}
                  align={column.align}
                  padding={column.isCheckbox ? "checkbox" : undefined}
                  sx={column.width ? { width: column.width } : undefined}
                >
                  <Skeleton
                    variant="text"
                    width={column.isCheckbox ? 20 : undefined}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
